import React, { useState, useEffect } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Moment from 'react-moment'
import FormDropdown from '../../Components/FormField/FormDropdown'
import { API } from "../../API"

//Backend
import axios from 'axios'
import { PORT } from '../../config'

const JobBoardComponent = ({
  job,
  bookings,
  users,
  campuses,
  insts,
  queryLastBooking,
}) => {
  const [showButton, setShowButton] = useState(false)
  const [selectedTeacher, setSelectedTeacher] = useState('')

  var campus, inst, inst_logo
  var assigned_user = null
  var default_option = null

  const [nonTeachingHourPerday, setNonteachingHour] = useState(0)

  for (var i = 0; i < campuses.length; i++) {
    if (job.campus_id == campuses[i]._id) {
      campus = campuses[i]
      break
    }
  }

  if (campus) {
    for (var i = 0; i < insts.length; i++) {
      if (insts[i]._id == campus.institution_id) {
        inst = insts[i]
        break
      }
    }
  }

  if (inst) {
    inst_logo = inst.logo
  }

  for (var i = 0; i < users.length; i++) {
    if (users[i]._id === job.teacher_id) {
      assigned_user = users[i]
      break
    }
  }

  if (assigned_user !== null) {
    default_option = (
      // remove selected property, looks like the dropdown menu not showwing assigned teacher has been fixed - lieh
      <option>
        {assigned_user.first_name + ' ' + assigned_user.last_name}
      </option>
    )
  }

  useEffect(() => {
    const mins = job.paid_nonteaching_mins ? job.paid_nonteaching_mins : null
    const hours = mins ? null : job.paid_nonteaching_hours

    if (mins && job.multiple_date) {
      const weekly = job.non_teach_calculation === 'weekly'
      const days = job.days_of_delivery.split(',').length
      const hoursperday = (mins / (weekly ? days * 60 : 60)).toFixed(1)
      setNonteachingHour(hoursperday)
    } else if (mins) {
      const hoursperday = (mins / 60).toFixed(1)
      setNonteachingHour(hoursperday)
    } else if (hours) {
      setNonteachingHour(hours)
    } else {
      setNonteachingHour(0)
    }
  })

  const changeDropdown = (e) => {
    setShowButton(true)
    setSelectedTeacher(e.target.value)
  }

  const onClickAllocateTeacher = () => {
    try {
      API.assignTeacherToBooking({
        teacher_id: selectedTeacher,
        booking_id: job._id
      })
      .then(function (result) {
        console.log('update result', result)
        setShowButton(false)
      })
      .catch(function (err) {
        console.log(err)
      })

      // axios({
      //   method: 'post',
      //   url: `${PORT}/assignTeacherToBooking`,
      //   data: {
      //     teacher_id: selectedTeacher,
      //     // booking_id is just a variable here, still using correct job._id - lieh
      //     booking_id: job._id,
      //   },
      // })
        
    } catch (error) {
      alert(error)
    }
  }

  const bindAssignMultipleTeachersLink = (job) => {
    return (
      <Link
        className='w-100 btn btn-primary btn-block btn-c primary-button-no-margin-hover'
        to={{
          pathname: '/MultipleTeacherAllocation',
          state: { job: job, campuses: campuses, insts: insts },
        }}
      >
        Assign Multiple Teachers
      </Link>
    )
  }

  return (
    <div className='flex bg-white shadow-md m-4 p-6 rounded'>
      <div className='ml-4 '>
        <img
          //   className="md:h-24 rounded-full shadow-md"
          className='rounded-full shadow-md imageSize'
          src={inst_logo}
          alt='Logo'
        />
      </div>
      <div className='w-1/5 mb-4 flex flex-col justify-center mx-auto'>
        <p className='font-bold text-2xl'>
          {inst ? inst.institution_name : 'institution not found/deleted'}
        </p>
        <p className='text-base'>{job.level}</p>
        <p className='text-base'>
          {campus
            ? campus.address_line1 +
              (campus.address_line2 ? ', ' + campus.address_line2 : '')
            : 'campus not found/deleted'}
        </p>
      </div>

      {/* address_line1 + (address_line2 ? lin2 : '') */}

      <div className='w-1/5 mb-4 flex flex-col justify-center'>
        <h3 className='font-extrabold text-2xl'>Date and Time</h3>
        <p className='text-base'>
          Start: <Moment format='DD MMM YYYY'>{job.booking_date}</Moment>
        </p>
        <p className='text-base'>
          End: <Moment format='DD MMM YYYY'>{job.end_booking_date}</Moment>
        </p>
        {job.days_of_delivery ? (
          <p className='text-base'>Days of week: {job.days_of_delivery}</p>
        ) : null}
        <p className='text-base'>No.of lessons: {job.dates.length}</p>
        <p className='text-base'>Arrival time: {job.arrival_time}</p>
        <p className='text-base'>Start time: {job.start_time}</p>
        <p className='text-base'>End time: {job.end_time}</p>
      </div>

      <div className='w-1/5 mb-4 flex flex-col justify-center o'>
        <h3 className='font-extrabold text-2xl'>
          {(job.paid_teaching_hours + parseFloat(nonTeachingHourPerday)) *
            (job.dates ? job.dates.length : 1) +
            ' '}{' '}
          Hours Whole Booking
        </h3>
        <p className='text-base'>
          {job.paid_teaching_hours + ' '}
          Teaching hours per day
        </p>
        <p className='text-base'>
          {nonTeachingHourPerday + ' '}
          Non-teaching hours per day
        </p>
        <p className='text-base'>
          {job.paid_teaching_hours + parseFloat(nonTeachingHourPerday) + ' '}
          Total hours per day
        </p>
      </div>

      <div className='w-1/5 mb-4 flex flex-col justify-center'>
        <div className='font-extrabold text-base'>{job.payment_status}</div>
        <div className='mr-auto'>
          {!job.multiple_date ? (
            <FormDropdown
              id='user_list'
              //label='Assign a Teacher'
              onChange={changeDropdown}
              selected={assigned_user == null ? '' : assigned_user}
            >
              {default_option}
              <option value={'None'}>None</option>
              {users.map((user) => checkOverlap(user, bookings, job))}
            </FormDropdown>
          ) : (
            bindAssignMultipleTeachersLink(job)
          )}
        </div>
      </div>
      {showButton && (
        <div className='w-1/5 mb-6 flex flex-col justify-center'>
          <button
            type='button'
            className='btn btn-secondary btn-sm'
            onClick={onClickAllocateTeacher}
          >
            Submit
          </button>
        </div>
      )}
    </div>
  )
}

const checkOverlap = (user, bookings, job) => {
  var userBookings = bookings.filter(
    (booking) => booking.teacher_id == user._id
  )

  for (var i = 0; i < userBookings.length; i++) {
    if (
      userBookings[i].teacher_response == 'accepted' &&
      userBookings[i].booking_date == job.booking_date &&
      userBookings[i]._id !== job._id
    ) {
      if (checkOverlapFunction(userBookings[i], job)) {
        return (
          <option value={user._id} key={user._id} style={{ color: 'grey' }}>
            {user.first_name + ' ' + user.last_name + ' ' + '(overlap)'}
          </option>
        )
      }
    }
  }

  return (
    <option value={user._id} key={user._id}>
      {user.first_name + ' ' + user.last_name}
    </option>
  )
}

const checkOverlapFunction = (booking, job) => {
  var bookingArrivalTime = new Date()
  var bookingEndTime = new Date()
  var jobArrivalTime = new Date()
  var jobEndTime = new Date()

  bookingArrivalTime.setHours(
    booking.arrival_time.split(':')[0],
    booking.arrival_time.split(':')[1],
    booking.arrival_time.split(':')[2],
    0
  )
  bookingEndTime.setHours(
    booking.end_time.split(':')[0],
    booking.end_time.split(':')[1],
    booking.end_time.split(':')[2],
    0
  )

  jobArrivalTime.setHours(
    job.arrival_time.split(':')[0],
    job.arrival_time.split(':')[1],
    job.arrival_time.split(':')[2],
    0
  )
  jobEndTime.setHours(
    job.end_time.split(':')[0],
    job.end_time.split(':')[1],
    job.end_time.split(':')[2],
    0
  )

  if (bookingArrivalTime <= jobEndTime && jobArrivalTime <= bookingEndTime) {
    return true
  }
  return false
}

export default withRouter(JobBoardComponent)
